  <div class="container-fluid p-0">
    <!-- Header Section -->
    <div class="custom-header text-white p-4 d-flex justify-content-between align-items-start">
      <div>
        <h4 class=" fw-bold mb-2" >EASYTRUST</h4>
        <div class="small text-xs">
          <p class="mb-1">126 Heidelberg Road, City Deep</p>
          <p class="mb-1">Johannesburg, 2197</p>
          <p class="mb-0">South Africa</p>
        </div>
      </div>
      <div class="text-end">
        <h4 class="fw-bold mb-2" >QUOTE</h4>
        <div class="small text-xs">
          <p class="mb-1"><strong>Quote #:</strong> {{ quote_data.quote_number }}</p>
          <p class="mb-1"><strong>Issue Date:</strong> {{ quote_data.issue_date }}</p>
          <p class="mb-0 text-info"><strong>Valid Until:</strong> {{ quote_data.valid_until }}</p>
        </div>
      </div>
    </div>

    <!-- Quote To Section -->
    <div class="p-4 border-bottom">
      <p class="mb-1 text-dark text-sm">Quote To:</p>
      <div>
        <p class="fw-bold mb-1 text-dark  text-xs">{{ quote_data.client_name }}</p>
        <p class="mb-0 text-dark text-xs">Email: <span class="text-dark">{{ quote_data.client_email }}</span></p>
      </div>
    </div>

    <!-- Decline Instructions -->
    <div class="mx-4 my-3" v-if="quote_data.quote_status === 'Rejected'">
      <div class="alert alert-danger border-danger">
          <p class="mb-1 text-xs fw-bold">This quote was declined.</p>
          <p class="mb-0 text-xs" v-if="quote_data.rejection_reason">
            <span class="fw-bold">Reason:</span> {{ quote_data.rejection_reason }}
          </p>
      </div>
    </div>

    <!-- Default Instructions -->
    <div class="mx-4 my-3" v-else>
      <div class="alert alert-info border-info">
        <p class="mb-0 text-xs">
          Please review the services below and select what you'd like to include in your order. Click the checkboxes to accept individual services.
        </p>
      </div>
    </div>

    <!-- Service Selection -->
    <div class="mx-4 mb-4">
      <!-- Main Service Card -->
      <div class="card border mt-3" v-for="main_service in quote_data.main_service" :key="main_service.id">
        <div class="card-body p-0">
          <!-- Service Selection Row -->
          <div class="d-flex align-items-center p-3 border-bottom bg-light">
            <div class="me-3">
              <input
                type="checkbox"
                v-model="selectedServices"
                :value="{ service_package: main_service.id, amount: main_service.total }"
                class="form-check-input"

              />
            </div>
            <div class="flex-grow-1 d-flex justify-content-between align-items-center">
              <div>
                <p class="fw-bold mb-0 text-dark text-xs ">{{ main_service.name }}</p>
              </div>
              <div class="text-end">
                <div class="fw-bold mb-0 text-dark text-xs ">{{ format_currency(main_service.total) }}</div>
              </div>
            </div>
            <div class="ms-3">
                <button
                    class="btn btn-sm btn-outline-secondary d-flex align-items-center"
                    type="button"
                    @click="toggle_accordion(main_service.id)"
                    :aria-expanded="openAccordions.includes(main_service.id)"
                    >
                    <span class="me-2 text-xs">
                        {{ openAccordions.includes(main_service.id) ? 'Hide' : 'Show' }} Details
                    </span>
                    <!-- svg icon -->
                </button>
            </div>
          </div>

          <!-- Expandable Details -->
          <div v-show="openAccordions.includes(main_service.id)" class="border-top">
            <div class="p-3 bg-white">
              <p class="text-muted mb-3 text-xs">What's included in {{ main_service.name }}:</p>
              <div class="row">
                <div class="col-12">
                  <ul class="list-unstyled mb-0">
                    <li v-for="subService in main_service.sub_services" :key="subService.id" class="mb-2 d-flex align-items-center">
                      <div class="me-3">
                        <div class=" d-flex align-items-center justify-content-center">
                          <svg width="12" height="12" fill="white">
                            <path d="M3.5 7l2 2 5-5" stroke="currentColor" stroke-width="2" fill="none"/>
                          </svg>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <div class="text-xs">{{ subService.name }}</div>
                        <small class="text-muted text-xs">Included at no additional cost</small>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Detailed Breakdown Table -->
            <div class="border-top d-none">
              <div class="p-3 bg-light">
                <p class="mb-3 text-xs">Service Breakdown:</p>
                <div class="table-responsive">
                  <table class="table-responsive w-100 table table-hover mt-3">
                    <thead>
                      <tr class="table-secondary">
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Service</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Quantity</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Unit Price</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">VAT</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-xxs text-start"><strong>{{ main_service.name }}</strong></td>
                        <td class="text-xxs text-start">{{ main_service.qty || '1' }}</td>
                        <td class="text-xxs text-start">{{ format_currency(main_service.unit_price) }}</td>
                        <td class="text-xxs text-start">{{ format_currency(main_service.vat) }}</td>
                        <td class="text-xxs text-start"><strong>{{ format_currency(main_service.total) }}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Help Text -->
      <div class="mt-3 text-xs" v-if="quote_data.quote_status !== 'Rejected'">
        <div class="alert alert-info border-0" >
          <div class="d-flex align-items-center">
            <div class="me-3">
              <svg width="20" height="20" fill="#1976d2">
                <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2" fill="none"/>
                <path d="M10 7v4M10 13h.01" stroke="currentColor" stroke-width="2" fill="none"/>
              </svg>
            </div>
            <div>
              <strong>How it works:</strong> Check the box above to accept the a service.
              All listed sub-services are included in the price. Click "Show Details" to see exactly what you're getting.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Section -->
    <div class="mx-4 mb-4">
      <div class="card bg-light">
        <div class="card-body">
          <p class="card-title mb-3  text-xs">Summary</p>
          <div class="d-flex justify-content-between mb-2">
            <span class="me-2 text-xs">Main Services Selected: {{ selectedServices.length }}</span>
            <span class="me-2 text-xs">{{ format_currency(calculated_totals.subtotal) }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2 d-none">
            <span class="me-2 text-xs">VAT :</span>
            <span class="me-2 text-xs">{{ format_currency(calculated_totals.vat) }}</span>
          </div>
          <hr class="border-dark border-2">
          <div class="d-flex justify-content-between fs-5 fw-bold">
            <span class="me-2 text-xs">Total Amount:</span>
            <span class="me-2 text-xs">{{ format_currency(calculated_totals.total) }}</span>
            <input
                type="checkbox"
                v-model="quote_total"
                :value="format_currency(calculated_totals.total)"
                class="form-check-input d-none"
              />

          </div>
          <div class="d-flex gap-3 flex-wrap mt-4" v-if="quote_data.quote_status !== 'Rejected'">
            <button
              @click="accept_quote"
              :disabled="selectedServices.length === 0"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              :class="{ 'disabled': selectedServices.length === 0 }"
            >
              Accept Selected Services
            </button>
            <button
                data-bs-toggle="modal"
                data-bs-target="#decline_quote"
              class="btn btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark">
              Decline Quote
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Action Buttons -->
    <div class="p-4">

    </div>
  </div>

  <teleport to="body">
  <div class="modal fade" id="decline_quote" tabindex="-1" aria-labelledby="edit_service_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title text-white text-xxs">Decline Quote</h5>
        <button type="button" class="modal-btn-close btn-close"data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Reason for declining quote</label>
              <textarea
                type="text" class="modal-form-control form-control text-xxs"
                v-model="decline_reason"
                placeholder="Enter the reason for declining the quote provided">
              </textarea>
          </div>

        </div>
        <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"  @click="decline_quote">
          Decline
        </button>

        </div>
    </div>
    </div>
</div>
</teleport>